import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 저장소 목록 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getLmsDataindexList(param) {
    return axios.post(`${baseUrl}/settings/lms-dataindex/get-lms-dataindex-list.do`, param);
  },
  /**
   * 저장소 구성 필드 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getDataindexField(params) {
    return axios.post(`${baseUrl}/settings/lms-dataindex/get-dataindex-field.do`, params);
  },
  /**
   * 저장소 패턴 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getDataindexPattern(params) {
    return axios.post(`${baseUrl}/settings/lms-dataindex/get-dataindex-pattern.do`, params);
  },
  /**
   * lms field info 테이블의 데이터 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getLmsFieldinfo() {
    return axios.get(`${baseUrl}/settings/lms-dataindex/get-lms-field-info.do`);
  },
  /**
   * 선택한 파싱 로그 패턴 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getDataindexPatternField(params) {
    return axios.post(`${baseUrl}/settings/lms-dataindex/get-dataindex-pattern-field.do`, params);
  },
  /**
   * 저장소 수정
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateDataindex(params) {
    return axios.post(`${baseUrl}/settings/lms-dataindex/update-dataindex.do`, params);
  },

  /**
   * 저장소 파싱 패턴 삭제
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteDataindexPattern(params) {
    return axios.post(`${baseUrl}/settings/lms-dataindex/delete-dataindex-pattern.do`, params);
  },
  /**
   * 저장소 추가
   * @author leesy918
   * @param  {[type]} querystring [description]
   * @param  {[type]} payload     [description]
   */
  addDataindex(querystring, payload) {
    return axios.post(`${baseUrl}/settings/lms-dataindex/add-dataindex.do?${querystring}`, payload);
  },
  /**
   * 저장소 파싱 패턴 추가
   * @author leesy918
   * @param  {[type]} querystring [description]
   * @param  {[type]} payload     [description]
   */
  addParsingPattern(querystring, payload) {
    return axios.post(`${baseUrl}/settings/lms-dataindex/add-parsing-pattern.do?${querystring}`, payload);
  },
  /**
   * 파싱 패턴 수정
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateParsingPattern(params) {
    return axios.post(`${baseUrl}/settings/lms-dataindex/update-parsing-pattern.do`, params);
  },
  /**
   * 저장소 추가 시 dataindex_id의 중복을 확인한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkDataindexId(params) {
    return axios.get(`${baseUrl}/settings/lms-dataindex/check-dataindex-id.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/lms-dataindex-setting.js